
export const root = {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{form.field.filled.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    borderColor: '{form.field.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    color: '{form.field.color}',
    disabledColor: '{form.field.disabled.color}',
    placeholderColor: '{form.field.placeholder.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '0.75rem',
    paddingY: '0.5rem',
    borderRadius: '{form.field.border.radius}',
    fontSize: '0.875rem', // 14px
    fontWeight: '300', // Light weight for input text
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    },
    transitionDuration: '{form.field.transition.duration}',
    sm: {
        fontSize: '0.75rem',
        paddingX: '0.625rem',
        paddingY: '0.375rem'
    },
    lg: {
        fontSize: '1rem',
        paddingX: '0.875rem',
        paddingY: '0.625rem'
    }
};

// PrimeNG hardcodes font-size: 1rem on .p-inputtext — override via css callback
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-inputtext {
    font-size: ${dt('inputtext.font.size')};
    font-weight: ${dt('inputtext.font.weight')};
}
`;

export default {
    root,
    css
};
